export const getFormattedAmount = (amount: string | number) => {
  const formatted = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    trailingZeroDisplay: "stripIfInteger",
  });

  return formatted.format(Number(amount));
};

export function parseScore(score: string) {
  const scoreValue = parseFloat(score);
  if (Number.isNaN(scoreValue)) return null;
  return scoreValue.toFixed(1);
}
